// Polyfill untuk modul Node.js yang tidak tersedia di browser
// File ini hanya berisi side effects, tidak ada export

// Polyfill untuk perf_hooks
if (typeof window !== 'undefined' && !window.performance) {
  // Fallback sederhana jika performance API tidak tersedia
  (window as any).performance = {
    now: () => Date.now(),
    mark: () => {},
    measure: () => {},
    getEntriesByType: () => [],
    getEntriesByName: () => [],
    clearMarks: () => {},
    clearMeasures: () => {},
    clearResourceTimings: () => {},
  };
}

// Polyfill untuk process
if (typeof window !== 'undefined' && !(window as any).process) {
  (window as any).process = {
    env: {},
    version: '',
    versions: {},
    platform: 'browser',
    arch: 'x64',
    cwd: () => '/',
    nextTick: (fn: Function) => setTimeout(fn, 0),
  };
}

// Polyfill untuk Buffer
if (typeof window !== 'undefined' && !(window as any).Buffer) {
  (window as any).Buffer = {
    from: (data: any) => new Uint8Array(data),
    alloc: (size: number) => new Uint8Array(size),
    allocUnsafe: (size: number) => new Uint8Array(size),
    isBuffer: (obj: any) => obj instanceof Uint8Array,
  };
}

// Polyfill untuk util
if (typeof window !== 'undefined' && !(window as any).util) {
  (window as any).util = {
    inspect: (obj: any) => JSON.stringify(obj),
    format: (...args: any[]) => args.join(' '),
    inherits: () => {},
  };
}

// Polyfill untuk events
if (typeof window !== 'undefined' && !(window as any).EventEmitter) {
  class EventEmitter {
    private events: Record<string, Function[]> = {};

    on(event: string, listener: Function) {
      if (!this.events[event]) {
        this.events[event] = [];
      }
      this.events[event].push(listener);
    }

    emit(event: string, ...args: any[]) {
      if (this.events[event]) {
        this.events[event].forEach(listener => listener(...args));
      }
    }

    removeListener(event: string, listener: Function) {
      if (this.events[event]) {
        this.events[event] = this.events[event].filter(l => l !== listener);
      }
    }
  }
  
  (window as any).EventEmitter = EventEmitter;
} 